export const smallView = require('../assets/small_view.png');
export const fullScreen = require('../assets/full_screen.png');
export const upload = require('../assets/upload.png');
export const user = require('../assets/user.png');
